import React from "react";
import DynamicField from "./DynamicField";
import type { DynamicFormProps } from "./types";

const DynamicForm: React.FC<DynamicFormProps> = (props) => {
  const { fields } = props;
  return (
    <React.Fragment>
      {fields.map((f) => (
        <DynamicField key={f.name} field={f} />
      ))}
    </React.Fragment>
  );
};

export default DynamicForm;
